import script from "./TutorDashboardPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorDashboardPage.vue?vue&type=script&setup=true&lang=js"

import "./TutorDashboardPage.vue?vue&type=style&index=0&id=fbb4f3f6&lang=css"

const __exports__ = script;

export default __exports__